import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";
import Balances from "@/pages/Pages/Finances/Balances.vue";
import TopUpBalance from "@/pages/Pages/Finances/TopUpBalance.vue";
import Overdrafts from "@/pages/Pages/Finances/Overdrafts.vue";
import OverdraftSettings from "@/pages/Pages/Finances/OverdraftSettings.vue";

let financesMenu = {
  path: "/finances",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/finances/overdrafts",
  name: "Finances",
  children: [
    {
      path: "balances",
      name: "balances",
      components: { default: Balances },
      meta:{
        icon: "account_balance_wallet",
        msgKey: 'menu.item.finance.balances'
      }
    },
    {
      path: "balances/top_up",
      name: "top_up_balance",
      components: { default: TopUpBalance },
      meta:{
        icon: "account_balance_wallet",
        parentPath: "/finances/overdrafts",
        msgKey: 'menu.item.finance.balances'
      }
    },
    {
      path: "overdrafts",
      name: "overdrafts",
      components: { default: Overdrafts },
      meta:{
        icon: "account_balance_wallet",
        msgKey: 'menu.item.finance.overdrafts'
      }
    },
    {
      path: "overdrafts/settings",
      name: "overdraft_settings",
      components: { default: OverdraftSettings },
      meta:{
        icon: "account_balance_wallet",
        parentPath: "/finances/overdrafts",
        msgKey: 'menu.item.finance.overdrafts'
      }
    },
  ]
}

export default financesMenu;
